import React, { useState } from "react";
import { Stack, Typography } from "@mui/material";
import dayjs from "dayjs";

import { StyledHubHookFormDatePicker, StyledHubHookFormSelect } from "./styles";
import { HubHookFormDatePicker, HubHookFormSwitch } from "../../components";
import { useFormContext } from "react-hook-form";

const FOLLOW_UP_OPTIONS = [
  { id: 1, label: "Daily" },
  { id: 2, label: "Weekly" },
  { id: 3, label: "Monthly" },
  { id: 4, label: "Custom" },
];

const AddWorkOrderRepeat = ({ disabled }) => {
  const defaultDate = dayjs().utc().format("MM/DD/YYYY");
  const { watch } = useFormContext();

  const [followUp, setFollowUp] = useState(4);
  const [date, setDate] = useState(defaultDate);

  const handleFollowUpChange = (e) => {
    const selected = e?.target?.value;
    const option = FOLLOW_UP_OPTIONS.find((f) => f.id === selected);

    setFollowUp(option?.id || 2);
  };

  const handleDateChage = (value) => setDate(value);
  const isRepeat = watch("isRepeat");

  return (
    <Stack gap="15px">
      <HubHookFormDatePicker
        name="repeatStartDate"
        label="Start Date"
        placeholder="MM/DD/YYYY"
        defaultValue={date}
        disabled={disabled}
        onChange={handleDateChage}
      />
      <Stack direction="row" gap="10px" alignItems="center">
        <HubHookFormSwitch
          name="isRepeat"
          label="Repeat Batches"
          labelPlacement="end"
          disableHelperText
          fullWidth={false}
          required={false}
          isCheckbox
          formControlProps={{
            sx: { minWidth: "auto" },
          }}
          labelProps={{
            sx: { textWrap: "nowrap" },
          }}
        />
        {isRepeat && (
          <StyledHubHookFormSelect
            name="repeatOption"
            defaultValue={followUp}
            options={FOLLOW_UP_OPTIONS}
            onChange={handleFollowUpChange}
            fullWidth={false}
            disabled={disabled}
          />
        )}
      </Stack>
    </Stack>
  );
};

export default AddWorkOrderRepeat;
